import { usePopup, type PopupId } from '@/composables/usePopup.ts'
import { computed } from 'vue'

export function useSpecificPopup(name: PopupId) {
  const { getPopup, showPopup, hidePopup } = usePopup()

  const popup = computed(() => {
    return getPopup(name)
  })

  const isVisible = computed(() => {
    return popup.value.visible
  })
  const show = () => {
    showPopup(name)
  }

  const hide = () => {
    hidePopup(name)
  }

  return {
    popup,
    isVisible,
    show,
    hide
  }
}
